import { __decorate, __metadata } from "tslib";
import { Component, Prop, Watch } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
const ANIMATION_FPS = 60;
export const COMPONENT_NAME = "LvProgressCircle";
let LvProgressCircle = class LvProgressCircle extends UIComponent {
    constructor() {
        super(...arguments);
        this.gradientAnimationIntervalId = null;
        this.currentAngle = 0;
        this.strokeDashoffset = 0;
        this.gradient = {
            fx: 0.99,
            fy: 0.5,
            cx: 0.5,
            cy: 0.5,
            r: 0.65,
        };
    }
    created() {
        this.changeProgress({ isAnimate: true });
    }
    get classList() {
        return [
            this.state,
            this.indeterminate ? "indeterminate" : null,
        ].filter(x => x != null);
    }
    get displayProgress() {
        if (this.indeterminate) {
            return 25;
        }
        else {
            return this.progress;
        }
    }
    get radius() {
        return this.size / 2;
    }
    get circumference() {
        return Math.PI * this.innerCircleDiameter;
    }
    get circleSlice() {
        return 2 * Math.PI / 100;
    }
    get animateSlice() {
        return this.circleSlice / this.totalPoints;
    }
    get innerCircleDiameter() {
        return this.size - (this.innerStrokeWidth * 2);
    }
    get innerCircleRadius() {
        return this.innerCircleDiameter / 2;
    }
    get totalPoints() {
        return this.animateSpeed / this.animationIncrements;
    }
    get animationIncrements() {
        return 1000 / ANIMATION_FPS;
    }
    get containerStyle() {
        return {
            height: `${this.size}px`,
            width: `${this.size}px`,
        };
    }
    get progressStyle() {
        return {
            height: `${this.size}px`,
            width: `${this.size}px`,
            strokeWidth: `${this.strokeWidth}px`,
            strokeDashoffset: this.strokeDashoffset,
            transition: `stroke-dashoffset ${this.animateSpeed}ms ${this.timingFunc}`,
        };
    }
    get strokeStyle() {
        return {
            height: `${this.size}px`,
            width: `${this.size}px`,
            strokeWidth: `${this.innerStrokeWidth}px`,
        };
    }
    get innerCircleStyle() {
        return {
            width: `${this.innerCircleDiameter}px`,
        };
    }
    getPointOfCircle(angle) {
        const radius = 0.5;
        const x = radius + (radius * Math.cos(angle));
        const y = radius + (radius * Math.sin(angle));
        return { x, y };
    }
    goToPoint() {
        const point = this.getPointOfCircle(this.currentAngle);
        if (point.x && point.y) {
            this.gradient.fx = point.x;
            this.gradient.fy = point.y;
        }
    }
    changeProgress({ isAnimate = true }) {
        this.strokeDashoffset = ((100 - this.displayProgress) / 100) * this.circumference;
        if (this.gradientAnimationIntervalId) {
            clearInterval(this.gradientAnimationIntervalId);
        }
        if (!isAnimate) {
            this.gotoNextStep();
            return;
        }
        const angleOffset = (this.displayProgress - 1) * this.circleSlice;
        let i = (this.currentAngle - angleOffset) / this.animateSlice;
        const incrementer = Math.abs(i - this.totalPoints) / this.totalPoints;
        const isMoveForward = i < this.totalPoints;
        this.gradientAnimationIntervalId = setInterval(() => {
            if (isMoveForward && i >= this.totalPoints ||
                !isMoveForward && i < this.totalPoints) {
                clearInterval(this.gradientAnimationIntervalId);
                return;
            }
            this.currentAngle = angleOffset + (this.animateSlice * i);
            this.goToPoint();
            i += isMoveForward ? incrementer : -incrementer;
        }, this.animationIncrements);
    }
    gotoNextStep() {
        this.currentAngle = this.displayProgress * this.circleSlice;
        this.goToPoint();
    }
    onDisplayProgressChange() {
        this.changeProgress({ isAnimate: true });
    }
    onSizeChange() {
        this.changeProgress({ isAnimate: true });
    }
    onStrokeWidthChange() {
        this.changeProgress({ isAnimate: true });
    }
};
__decorate([
    Prop({ type: Number, required: false, default: 0 }),
    __metadata("design:type", Number)
], LvProgressCircle.prototype, "progress", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], LvProgressCircle.prototype, "showValue", void 0);
__decorate([
    Prop({ type: String, required: false, default: "primary" }),
    __metadata("design:type", String)
], LvProgressCircle.prototype, "state", void 0);
__decorate([
    Prop({ type: Number, required: false, default: 200 }),
    __metadata("design:type", Number)
], LvProgressCircle.prototype, "size", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LvProgressCircle.prototype, "indeterminate", void 0);
__decorate([
    Prop({ type: Number, required: false, default: 10 }),
    __metadata("design:type", Number)
], LvProgressCircle.prototype, "strokeWidth", void 0);
__decorate([
    Prop({ type: Number, required: false, default: 5 }),
    __metadata("design:type", Number)
], LvProgressCircle.prototype, "innerStrokeWidth", void 0);
__decorate([
    Prop({ type: Number, required: false, default: 300 }),
    __metadata("design:type", Number)
], LvProgressCircle.prototype, "animateSpeed", void 0);
__decorate([
    Prop({ type: String, required: false, default: "#f3f3f3" }),
    __metadata("design:type", String)
], LvProgressCircle.prototype, "innerStrokeColor", void 0);
__decorate([
    Prop({ type: String, required: false, default: "linear" }),
    __metadata("design:type", String)
], LvProgressCircle.prototype, "timingFunc", void 0);
__decorate([
    Watch("displayProgress"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LvProgressCircle.prototype, "onDisplayProgressChange", null);
__decorate([
    Watch("size"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LvProgressCircle.prototype, "onSizeChange", null);
__decorate([
    Watch("strokeWidth"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LvProgressCircle.prototype, "onStrokeWidthChange", null);
LvProgressCircle = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvProgressCircle);
export default LvProgressCircle;
//# sourceMappingURL=script.js.map